import { Component } from '@angular/core';
import { IonicPage, NavController, AlertController, LoadingController, NavParams, Events,Platform } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { Slides,ModalController } from 'ionic-angular';
import { ViewChild } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';
import { DashBoardPage } from '../dash-board/dash-board';
import {ThankuPage} from '../thanku/thanku';
import {Location} from '@angular/common';
import { ContactPage } from '../contact/contact';
import { AppPersonalInfoPage } from '../app-personal-info/app-personal-info';
import { App } from "ionic-angular"
import { LeadThankYouPage } from '../lead-thank-you/lead-thank-you';
import { Storage } from '@ionic/storage';
// import { InAppBrowser } from '@ionic-native/in-app-browser';
// declare var IRoot:any;
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild(Slides) slides: Slides;

  token: any = undefined
  mobileNumber: any = "";
  arrResponce: any = [];
  arrResponceCustomerData: any = []
  username:any=undefined;
  slideConfig = {autoHeight: true};
   
  cust_number:any ="" ;
  cust_name:any ="";
  cust_email:any = "";
  getAllLoanDetails:any=[];

   
  cifNumber: any = "";
   
  constructor(public loadingCtrl: LoadingController,public navCtrl: NavController,
    private navParams: NavParams, public cp: CommonProvider,platform: Platform,
    public events: Events,private location:Location,public modalCtrl: ModalController,
    private app:App,public alertCtrl: AlertController,private storage: Storage) {
     
     

  }
ionViewDidLoad(){
    //this.checkAppVersion()
     if(!localStorage.getItem("defaultPhoneLength")){
      localStorage.setItem("phoneLength","10");
    }else{
      localStorage.setItem("phoneLength",localStorage.getItem("defaultPhoneLength"));
      
    }
    if(localStorage.getItem("token")){
      let user:any=localStorage.getItem("token");
      this.events.publish('user:created',user , Date.now());
      this.cust_number = "";
      this.cust_name = "";
      this.cust_email = "";
    }else{
      this.events.unsubscribe("user")
    }
    if(window.location.href.indexOf("?app=")>-1){
      
        this.showAlertForCheckVersion("Update Android New Version Please Update Through Playstore","Update","https://play.google.com/store/apps/details?id=com.ib.eHomeloans&pli=1")
    }
     
     if(window.location.href.indexOf("?ORDER_ID=")>-1){
       var strPaymentData=decodeURI(window.location.href.split("?")[1].split("ORDER_ID=")[1]);
           strPaymentData=strPaymentData+"|patm" 
       this.location.replaceState('/');
        this.navCtrl.setRoot(ThankuPage, {data:strPaymentData,replaceUrl:true});
    }
    else if(window.location.href.indexOf("?techprocess=")>-1){
       var strPaymentData=decodeURI(window.location.href.split("?")[1].split("techprocess")[1].split("msg=")[1]);
           strPaymentData=strPaymentData+"|techprocess" 
       this.location.replaceState('/');
        this.navCtrl.setRoot(ThankuPage, {data:strPaymentData,replaceUrl:true});
        return
    }else{

      console.log(this.navParams.get("mobile"),"mobile",this.navParams.get("cifNumber"))
      if (this.navParams.get("mobile")) {

          this.mobileNumber = this.navParams.get("mobile");
          this.storage.set("mobile", this.navParams.get("mobile"));
          localStorage.setItem("mobile", this.navParams.get("mobile"))
      }else if(this.navParams.get("cifNumber")){
        this.cifNumber = this.navParams.get("cifNumber");
        this.storage.set("cifNumber", this.navParams.get("cifNumber"));
        localStorage.setItem("cifNumber", this.navParams.get("cifNumber"))
      }
      else {
        this.mobileNumber = localStorage.getItem("mobile");
        this.cifNumber = localStorage.getItem("cifNumber");
      }
      if (!this.mobileNumber) {
        if(!this.cifNumber){
          //localStorage.clear()
        }else{
          this.getLightApiData()
        }
        
      } else {
        if(!this.cifNumber){
          //localStorage.clear()
        }else{
          this.getLightApiData()
        }
        this.getLightApiData()
      }

        if (localStorage.getItem("token")) {
          this.token = localStorage.getItem("token")
        } 
    }
     
    
  }
  // ionViewDidLoad(){
  //   //this.checkAppVersion()
  //    if(!localStorage.getItem("defaultPhoneLength")){
  //     localStorage.setItem("phoneLength","10");
  //   }else{
  //     localStorage.setItem("phoneLength",localStorage.getItem("defaultPhoneLength"));
      
  //   }
  //   if(localStorage.getItem("token")){
  //     let user:any=localStorage.getItem("token");
  //     this.events.publish('user:created',user , Date.now());
       
  //   }else{
  //     this.events.unsubscribe("user")
  //   }
  //   if(window.location.href.indexOf("?app=")>-1){
      
  //       this.showAlertForCheckVersion("Update Android New Version Please Update Through Playstore","Update","https://play.google.com/store/apps/details?id=com.ib.eHomeloans&pli=1")
  //   }
     
  //    if(window.location.href.indexOf("?ORDER_ID=")>-1){
  //      var strPaymentData=decodeURI(window.location.href.split("?")[1].split("ORDER_ID=")[1]);
  //          strPaymentData=strPaymentData+"|patm" 
  //      this.location.replaceState('/');
  //       this.navCtrl.setRoot(ThankuPage, {data:strPaymentData,replaceUrl:true});
  //   }
  //   else if(window.location.href.indexOf("?techprocess=")>-1){
  //      var strPaymentData=decodeURI(window.location.href.split("?")[1].split("techprocess")[1].split("msg=")[1]);
  //          strPaymentData=strPaymentData+"|techprocess" 
  //      this.location.replaceState('/');
  //       this.navCtrl.setRoot(ThankuPage, {data:strPaymentData,replaceUrl:true});
  //       return
  //   }else{
  //     if (this.navParams.get("mobile")) {
  //     this.mobileNumber = this.navParams.get("mobile");
  //     localStorage.setItem("mobile", this.navParams.get("mobile"))
  //   } else {
  //     this.mobileNumber = localStorage.getItem("mobile");
  //   }
  //   if (!this.mobileNumber) {
  //     localStorage.clear()
  //   } else {
  //     this.getLightApiData()
  //   }

  //   if (localStorage.getItem("token")) {
  //     this.token = localStorage.getItem("token")
  //   } 
  //   }
         
            
        
        
        
  // }

  
  slideChanged() {
    let currentIndex = this.slides.getActiveIndex();
    ////console.log('Current index is', currentIndex);
  }
  onClickLoginButton() {
    this.navCtrl.setRoot(LoginPage)
  }
  onClickLogoutButton() {
    this.token = undefined;
    localStorage.clear()
    this.events.publish('user:created', this.token, Date.now());
    this.navCtrl.setRoot(LoginPage)
  }
  goToSlide() {
    this.slides.slideTo(2, 500);
  }
  // getLightApiData() {
  //   let loading = this.loadingCtrl.create({
  //     content: 'Please wait...'
  //   });
  //   loading.present();
  //   let responcePromice =  this.cp.getLightApiData(loading,this.mobileNumber);
  //   responcePromice.then((res: any) => {
  //     loading.dismiss();
       
  //     var res = JSON.parse(res)
  //     this.arrResponce = res.Payload.leads;
  //     if (res.Payload.ibhfl_customerloans) {
  //       this.arrResponceCustomerData = res.Payload.ibhfl_customerloans;
  //       let addressDetails:any=[];
  //       let iframeDataArray:any=[];
  //       let iframeDataString:any=',';
  //       var i=0;
  //       let arrDataForChat:any=[];
  //       this.arrResponceCustomerData.forEach( (data:any)=>{
  //          this.cp.getDashBoardApiData(loading,data.ibhfl_name,data.customercode).then((resLan: any) => {

  //             addressDetails.push(JSON.parse(resLan).Payload.addressDetail.responseParameters.filter((resaddr:any)=>{
  //               return resaddr.addresstype == 'CURRES'
  //             }))
  //             // console.log(addressDetails,"addressDetails");
  //             let additionalData:any=[];
  //             additionalData=addressDetails[i].filter((res:any)=>{
  //               return res.applicanttype=="Applicant"

  //             });
               
  //             i=i+1;

  //             this.cust_number = additionalData[0].mobile;
  //             this.cust_name = additionalData[0].customername;
  //             this.cust_email = additionalData[0].emailid;
  //             this.getAllLoanDetails.push('tx_lan'+i+'='+additionalData[0].lanno+'|'+JSON.parse(resLan).Payload.loanParameterDetail.responseParameters[0].loanstatus+'|'+additionalData[0].customername+'|'+additionalData[0].mobile+'|'+additionalData[0].emailid)
  //             arrDataForChat['tx_number']=this.cust_number;
  //             arrDataForChat['tx_name']=this.cust_name;
  //             arrDataForChat['tx_email']=this.cust_email;
  //             arrDataForChat['tx_lan'+i]=additionalData[0].lanno+'|'+JSON.parse(resLan).Payload.loanParameterDetail.responseParameters[0].loanstatus+'|'+additionalData[0].customername+'|'+additionalData[0].mobile+'|'+additionalData[0].emailid;
  //             localStorage.setItem("cust_number",this.cust_number);
  //             localStorage.setItem("cust_name",this.cust_name)
  //             localStorage.setItem("cust_email",this.cust_email)
  //             localStorage.setItem("getAllLoanDetails",JSON.stringify(this.getAllLoanDetails))
            
  //             localStorage.setItem("arrDataForChat",JSON.stringify(Object.assign({},arrDataForChat)))
         
  //         })

  //       })
  //     }
      
  //     //console.log(res, "light api old");

  //   }).catch(err => {})
  // }

    getLightApiData() {
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let responcePromice:any;
    
    if(!this.mobileNumber){
      console.log(this.cifNumber);
       responcePromice =  this.cp.getLightApiData(loading,this.cifNumber,false);
    }else{
      console.log(this.mobileNumber);
       responcePromice =  this.cp.getLightApiData(loading,this.mobileNumber,true);
    }
    
    let cifRequest:any={};
    responcePromice.then((res: any) => {
      loading.dismiss();
       
      var res = JSON.parse(res)
      
      this.arrResponce = res.Payload.leads;

      if (res.Payload.ibhfl_customerloans.length>0) {
         
        //sessionStorage.setItem("successtoken",res.successEnc.successEnc);
        this.arrResponceCustomerData = res.Payload.ibhfl_customerloans;
        const data = res.Payload.ibhfl_customerloans;
        this.arrResponceCustomerData = data.filter((item: any) => {
                            return item["customer.mobilephone"] && item["customer.mobilephone"].trim() !== "";
                          });
                          
                          console.log(this.arrResponceCustomerData);
        //console.log(res.Payload.ibhfl_customerloans)
        //console.log(this.arrResponceCustomerData[0]["customer.mobilephone"],"yes")
        this.mobileNumber=this.arrResponceCustomerData[0]["customer.mobilephone"]
        localStorage.setItem("mobile", this.mobileNumber)
        let addressDetails:any=[];
        let iframeDataArray:any=[];
        let iframeDataString:any=',';
        var i=0;
        let arrDataForChat:any=[];

        this.arrResponceCustomerData.forEach( (data:any)=>{
          
           this.cp.getDashBoardApiData(loading,data.ibhfl_name,data.customercode).then((resLan: any) => {

              addressDetails.push(JSON.parse(resLan).Payload.addressDetail.responseParameters.filter((resaddr:any)=>{
                return resaddr.addresstype == 'CURRES'
              }))
              // console.log(addressDetails,"addressDetails");
              let additionalData:any=[];
              additionalData=addressDetails[i].filter((res:any)=>{
                return res.applicanttype=="Applicant"

              });
               
              i=i+1;

              this.cust_number = additionalData[0].mobile;
              this.cust_name = additionalData[0].customername;
              this.cust_email = additionalData[0].emailid;
              this.getAllLoanDetails.push('tx_lan'+i+'='+additionalData[0].lanno+'|'+JSON.parse(resLan).Payload.loanParameterDetail.responseParameters[0].loanstatus+'|'+additionalData[0].customername+'|'+additionalData[0].mobile+'|'+additionalData[0].emailid)
              arrDataForChat['tx_number']=this.cust_number;
              arrDataForChat['tx_name']=this.cust_name;
              arrDataForChat['tx_email']=this.cust_email;
              arrDataForChat['tx_lan'+i]=additionalData[0].lanno+'|'+JSON.parse(resLan).Payload.loanParameterDetail.responseParameters[0].loanstatus+'|'+additionalData[0].customername+'|'+additionalData[0].mobile+'|'+additionalData[0].emailid;
               
              localStorage.setItem("cust_number",this.cust_number);
              localStorage.setItem("cust_name",this.cust_name)
              localStorage.setItem("cust_email",this.cust_email)
              localStorage.setItem("getAllLoanDetails",JSON.stringify(this.getAllLoanDetails))
            
              localStorage.setItem("arrDataForChat",JSON.stringify(Object.assign({},arrDataForChat)))
               
          })

        })
      }
      
       

    }).catch(err => {})
    
  }
  showAlertForCheckVersion(msg,title,link) {
    const alert = this.alertCtrl.create({
      title:title,
      subTitle: msg,
      enableBackdropDismiss: false, 
      buttons: [{
          text: 'Ok',
          handler: data => {
            window.location.href=link;
              
          }
        }]
    });
    alert.present();
  }
  goToDashBoard(loannumber) {
    this.navCtrl.setRoot(DashBoardPage, { mobile: this.mobileNumber, loan: loannumber });
  }
  veiwLead(leadid){
     
    let request:any = {};
      request.leadId=leadid
      let loading = this.loadingCtrl.create({
       content: 'Please wait...'
      });
      loading.present();
      this.cp.viewLeadById(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
           
           if(JSON.parse(res).Payload.lead.ibhfl_stageid=="17"){
              this.navCtrl.setRoot(LeadThankYouPage,res);
             
           }else{
            this.navCtrl.setRoot(AppPersonalInfoPage,res)
           }
           
             
             
         }catch(e){
          //console.log(e)
         }
       })
  }
  showAlert(msg,title,link) {
    const alert = this.alertCtrl.create({
      title:title,
      subTitle: msg,
      enableBackdropDismiss: false, 
      buttons: [{
          text: 'Ok',
          handler: data => {
            window.location.href=link;
              
          }
        }]
    });
    alert.present();
  }
  checkAppVersion(){
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
      // var that = this;   
      let request:any={} 
      request.version=this.cp.VERSION;
      request.platform=this.cp.PLATFORM
      this.cp.checkLatestVersion(loading,request).then((resp:any)=>{
         loading.dismiss();
         try{
          //console.log(JSON.parse(resp));
           if(JSON.parse(resp).Message == 'FAILURE'){
            if(JSON.parse(resp).link){
              this.showAlert(JSON.parse(resp).Displaymessage,"Update",JSON.parse(resp).link)
            }else{
              this.showAlert(JSON.parse(resp).Displaymessage,"Update","https://www.google.com")
            }
              
              return false;
            }else{
              
                
            }

         }catch(e){
           // that.veiwLead(JSON.parse(this.navParams.data).Payload.lead.leadid)
         } 
           
      })
  }
  goToDashBoardForm(loantype){

    // ////console.log(loantype,localStorage.getItem("token"))
    if(loantype=='hl' && !localStorage.getItem("token")){
      this.navCtrl.setRoot(LoginPage,{'loantype':loantype})
    }else if(loantype=='lp' && !localStorage.getItem("token")){
      this.navCtrl.setRoot(LoginPage,{'loantype':loantype})
    }else{
      let request:any = {};
      request.lead={};
      request.lead.ibhfl_mobilephone1=localStorage.getItem("mobile").slice(-10)
      request.lead.ibhfl_leadsubsourceid = "Website"
      request.lead.ibhfl_purposeproduct=loantype=='hl'?loantype.toUpperCase():'LAP';
      request.lead.ibhfl_countrydialingcode=localStorage.getItem("mobile").slice(0, 2)
      request.lead.ibhfl_leadsourceid="Website"
      

      //console.log(request);

       // return false;
      let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
      var that = this;    
      this.cp.createLead(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
          //console.log(JSON.parse(res));
          if(JSON.parse(res).Error && JSON.parse(res).Error.ErrorCode==400){
            alert("You have created lead already !")
             
          }else{
            
            that.veiwLead(JSON.parse(res).Payload.lead.leadid)
             
          }

         }catch(e){
            
         } 
           
      })
      
      
    }
  }

 presentModal() {
    const modal = this.modalCtrl.create(ContactPage,{showBackdrop: false,
            enableBackdropDismiss: false});
    modal.present();
  }


  numberFormatter(x) {
    ////console.log(x)
    x = x.toString();
    var afterPoint = '';
    if (x.indexOf('.') > 0)
        afterPoint = x.substring(x.indexOf('.'), x.length);
    x = Math.floor(x);
    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers != '')
        lastThree = ',' + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
    return res;
}
 
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts